import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  return (
    <div className="privacy">
      <Header />
      <main><div className="inner-pg"><div className="content">
        <h1>Privacy Policy</h1>
        <p>Last updated: September 8, 2026</p>
        <p>shiskerstone respects your privacy. This notice explains the information we collect through our store, why we use it, and the choices available to you.</p>
        <strong>Information we collect</strong>
        <p>We may collect contact details, billing and delivery information, order history, messages you send us, device and browser information, and website activity. Payment card details are handled by the payment service used at checkout and are not retained by us in full.</p>
        <strong>How we use information</strong>
        <p>We use information to process and deliver orders, provide customer service, prevent fraud, operate and improve the website, meet legal obligations, and send marketing only where you have requested it or where permitted by law.</p>
        <strong>How information is shared</strong>
        <p>Information may be shared with service providers that support payments, hosting, delivery, analytics, communications, and professional advice. They may use it only for the services they provide to us. We may also disclose information where required by law or as part of a business reorganization.</p>
        <strong>Cookies</strong>
        <p>We use essential browser storage for functions such as the cart and may use optional analytics or preference technologies. More detail and browser controls are described in our Cookie Policy.</p>
        <strong>Retention and security</strong>
        <p>We keep personal information only for as long as reasonably needed for the purposes above, including tax, accounting, dispute, and fraud-prevention requirements. We use reasonable safeguards, although no internet transmission is completely secure.</p>
        <strong>Your choices and rights</strong>
        <p>Depending on where you live, you may request access, correction, deletion, restriction, portability, or objection to certain processing, and may withdraw consent. You may also unsubscribe from marketing at any time. Identity verification may be required before completing a request.</p>
        <strong>International processing</strong>
        <p>Our providers may process information outside your country. Where required, appropriate contractual or legal safeguards are used for those transfers.</p>
        <strong>Children</strong>
        <p>Our store is not directed to children, and we do not knowingly collect personal information from children below the minimum legal age in their location.</p>
        <strong>Changes and contact</strong>
        <p>We may update this notice to reflect operational or legal changes. The date above shows the latest revision. Questions or privacy requests can be sent to <u>print@shiskerstone.xyz</u>.</p>
      </div></div></main>
      <Footer />
    </div>
  );
}

export default Privacy;
